export default __webpack_public_path__ + "static/media/7t.2d9bb13e.jpg";